<template>
  <van-field
    v-bind="$attrs"
    :model-value="modelValue"
    :class="{ 'app-masked-password-field--masked': !visible }"
    :type="visible ? 'text' : 'password'"
    :name="name"
    autocomplete="off"
    autocapitalize="none"
    autocorrect="off"
    :spellcheck="false"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template v-if="$slots.button" #button>
      <slot name="button" />
    </template>
    <template v-if="$slots['right-icon']" #right-icon>
      <slot name="right-icon" />
    </template>
  </van-field>
</template>

<script setup>
defineOptions({ inheritAttrs: false });

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: "",
  },
  visible: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "secure-entry",
  },
});

const emit = defineEmits(["update:modelValue"]);
</script>

<style scoped lang="scss">
.app-masked-password-field--masked {
  :deep(.van-field__control) {
    // color: var(--van-field-input-text-color, #000000) !important;
    // -webkit-text-fill-color: var(--van-field-input-text-color, #000000);
    // caret-color: var(--van-field-input-text-color, #000000);
    font-family: Arial, sans-serif !important;
    // font-size: 18px !important;
    font-weight: 400 !important;
    letter-spacing: 2px !important;
    // line-height: 22px;
    // -webkit-text-security: disc;
  }
}
</style>
